const tagDataList = {
    default: {
        shareTitle: '이용권 : SBS',
        shareDescription: '신규 고객을 위한 특별할인',
        shareImageUrl: 'https://image.sbs.co.kr/sbs/4n/sbs_pass_thumb.png',
        currentUrl: 'https://www.sbs.co.kr/pass',
        keywords: 'SBS,에스비에스,뉸,sbs온에어,sbs실시간,www.sbs.co.kr,sbs.co.kr,지상파,VOD 무료,SBS 드라마 무료,sbskorea,sbstv,sbs편성표,sbs 韓国,sbs korean,서울방송,Seoul Broadcasting System'
    },
    pass: {shareTitle: '이용권 : SBS'},
    point: {shareTitle: '포인트 : SBS'},
    money: {shareTitle: '머니 : SBS'},
    coupon: {shareTitle: '쿠폰 : SBS'},
    couponEnter: {shareTitle: '쿠폰등록 : SBS'}
};

export default function index (pageSection, pageCategory = '') {
    //console.log('pageSection> ' + pageSection);

    let result = { ...tagDataList['default'], ...tagDataList[pageSection]};

    return { ...result };
}
